var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusUnavailable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Status-Unavailable") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Status-Unavailable",
    stroke: "#B5B5B5",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7888544,5.04972796 L19.2749469,16.021913 C19.7689254,17.00987 19.3684767,18.2112161 18.3805197,18.7051946 C18.1028088,18.84405 17.7965827,18.9163402 17.4860925,18.9163402 L6.51390748,18.9163402 C5.40933798,18.9163402 4.51390748,18.0209097 4.51390748,16.9163402 C4.51390748,16.60585 4.58619766,16.2996239 4.7250531,16.021913 L10.2111456,5.04972796 C10.7051241,4.06177096 11.9064702,3.66132227 12.8944272,4.15530077 C13.281482,4.34882817 13.595327,4.66267315 13.7888544,5.04972796 Z",
    id: "Triangle"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.63181939,
    y1: 11.2100914,
    x2: 14.3681806,
    y2: 15.9464526,
    id: "Path-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.3681806,
    y1: 11.2100914,
    x2: 9.63181939,
    y2: 15.9464526,
    id: "Path-7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusUnavailable);
export default __webpack_public_path__ + "static/media/Status-Unavailable.296171dc.svg";
export { ForwardRef as ReactComponent };